import { certChip } from "../certLabel";
import type { CertVerdict } from "../schemas";

const TONE = {
  ok: "border-emerald-300 bg-emerald-50 text-emerald-800",
  warn: "border-amber-300 bg-amber-50 text-amber-800",
  muted: "border-border bg-muted text-muted-foreground",
} as const;

/** Chip chứng chỉ cạnh tên người (spec §7.1). Không render gì khi dòng không kiểm. */
export function CertChip({
  verdict,
  className = "",
}: {
  verdict: CertVerdict | null | undefined;
  className?: string;
}) {
  const chip = certChip(verdict);
  if (!chip) return null;
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-md border px-1.5 py-0.5 text-[11px] font-medium ${TONE[chip.tone]} ${className}`}
      title={chip.text}
      data-tone={chip.tone}
    >
      {chip.text}
    </span>
  );
}
